import Vue from 'vue';
import Router from 'vue-router';
import Login from './components/Login.vue';

import Roster from './components/testroster/Roster.vue';


import StoreSettings from './components/storesettingcontext/StoreSettings.vue';
import EmployeeDataRequest from './components/employeecontext/EmployeeDataRequest.vue';

import Employees from './components/employeecontext/Employees.vue';
import ShiftMain from './components/shiftcontext/ShiftMain.vue';
import StoreMain from './components/storedatacontext/StoreMain.vue';

import StoreSalesMain from './components/storesalescontext/StoreSalesMain.vue'
import PreferenceMain from './components/preferencecontext/PreferenceMain.vue'
import CalendarView from './components/preferencecontext/CalendarView.vue'
import Employeedatarequestoverview from './components/employeecontext/EmployeeDataRequestOverview.vue'

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/employeesnew',
      name: 'employeesnew',
      component: Employees,
      props: true
    },
    {
      path: '/storesettings',
      name: 'storesettings',
      component: StoreSettings,
      props: true
    },
    {
      path: '/employeedatarequest/:id/:token',
      name: 'employeedatarequest',
      component: EmployeeDataRequest,
      props: true
    },
    {
      path: '/musterdienstplan',
      name: 'roster',
      component: Roster,
      props: true
    },
    {
      path: '/planning',
      name: 'planning',
      component: ShiftMain,
      props: true
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: CalendarView,
      props: true
    },
    {
      path: '/storemain',
      name: 'storemain',
      component: StoreMain,
      props: true
    },
    {
      path: '/storesales',
      name: 'storesalesmain',
      component: StoreSalesMain,
      props: true
    },
    {
      path: '/preferences',
      name: 'preferences',
      component: PreferenceMain,
      props: true
    },
    {
      path: '/employeedatarequestoverview',
      name: 'employeedatarequestoverview',
      component: Employeedatarequestoverview,
      props: true
    }
  ]
})
